import $ from 'jquery'
import View from 'view/view'
import ModalView from 'component/modal/modal'
import template from 'bundle/event_guestlist/template/join_waiting_list_modal.tmpl'
import Router from 'service/router'
import dataProvider from 'service/data_provider'

const JoinWaitingListModalView = View.extend({
    events: {
        'click .js-join-waiting-list-submit': '_onSubmitButtonClick',
    },

    _onSubmitButtonClick() {
        this.options.parent.hide()
        this.trigger('JoinWaitingListModal:submit', this.options.target, true, 'PUT')
    },
})

const JoinWaitingListView = View.extend({
    template,

    initialize() {
        const $modalContent = $(
            this.template({
                actionUrl: Router.path('event_guestlist_api_guestlists_waiting_list_entries_put', {
                    guestlistId: dataProvider.get('guestlistId'),
                }),
            })
        )

        const modal = this.initSubview(ModalView, {
            content: $modalContent,
            fullHeight: true,
            classes: 't-modal modal',
            initializeOnly: true,
        })

        modal
            .once('Modal:opened', (payload) => {
                this.initSubview(JoinWaitingListModalView, {
                    el: payload.container,
                    target: this.options.el,
                    parent: modal,
                })
            })
            .open()
    },
})

export default JoinWaitingListView
